module.exports = __webpack_public_path__ + "img/check-circle-border-white.cff573e6.svg";